import React, { Component } from 'react'
import { Dropdown } from 'react-bootstrap'
import { GET_WORKPLACE_GROUP_LIST } from '../../../../../../actions/api';
import NeedHelp from '../Elements/NeedHelp';
import HttpClient from '../../../../../../actions/http-client';
import { TOAST_ERROR } from '../../../../../../utils';
import { getInitialRoute } from '../../../../../../utils';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';
import { createFeedAction } from '../../../../../../actions/addFeedActions';

class WorkPlacefeed extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            community: '',
            accessToken: '',
            error: false,
            noAccFoundError: false,
            selectedAcc: null,
            isChecked: false,
            groupList: [],
            isAccountSelected: true
        }

    }

    handleOnChange = (e) => {
        this.setState({ [e.target.name]: e.target.value, error: false, noAccFoundError: false })
    }


    submit = () => {

        if (this.state.community != '' && this.state.accessToken != '') {
            this.setState({ loading: true });
            const { hideAddfeed, navigation, wallId, networkId } = this.props;
            const { isChecked, selectedAcc, accessToken, community } = this.state;

            if (this.state.selectedAcc !== null) {

                const postbody = {
                    wallId: wallId,
                    networkId: networkId,
                    filter: 22,
                    communityId: community,
                    accessToken: accessToken,
                    workplaceGroup: selectedAcc.name,
                    workplaceGroupId: selectedAcc.id,
                    connetedAccount: 0,
                    moderation: isChecked ? 1 : 0
                }

                createFeedAction(postbody, networkId, (feedId) => this.setState({ loading: false }, () => {
                    if (feedId) {
                        hideAddfeed();
                        navigation(`/moderation/index/${wallId}`);
                    }
                }));

            } else {
                this.getGroupList(() => this.setState({ loading: false }));
            }
        } else {
            this.setState({ error: true })
        }
    }


    getGroupList = (callback) => {
        new HttpClient()
            .post(`${GET_WORKPLACE_GROUP_LIST}`, {
                community: this.state.community,
                accessToken: this.state.accessToken
            })
            .then((response) => {
                const { responseCode, responseData } = response.data;
                callback();
                if (responseCode == 200) {
                    if (responseData && responseData.length > 0) {
                        this.setState({ groupList: responseData, isAccountSelected: false });
                    } else {
                        this.setState({ noAccFoundError: true });
                    }
                }
            }).catch((ex) => {
                const errorMsg = ex.response.data ? ex.response.data.resposneMessage : '';
                TOAST_ERROR(errorMsg);
                callback();
            })
    }

    handleSelect = (item) => {
        this.setState({ selectedAcc: item, isAccountSelected: true });
    } 

    render() {
        const { loading, community, accessToken, error, selectedAcc, noAccFoundError, isChecked, groupList, isAccountSelected } = this.state;
        const { onBack } = this.props;
        return (
            <>
                <div className="form-group pt-5 border-top">
                    <div className="form-group mb-5">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="fa fa-users"></i>
                                </span>
                            </div>
                            <InputField name={"community"} className={`form-control`} placeholder="Community ID" value={community} onChangeHandler={(e) => this.handleOnChange(e)} />
                        </div>
                    </div>
                    <div className="form-group mb-0">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="fas fa-key"></i>
                                </span>
                            </div>
                            <InputField name={"accessToken"} className={`form-control`} placeholder="Access Token" value={accessToken} onChangeHandler={(e) => this.handleOnChange(e)} />
                        </div>
                    </div>
                    {(groupList && groupList.length > 0) && <div id="workplace_div" className="form-group mb-0">
                        <label htmlFor="FeedWorkplaceGroup22">workplace group</label>
                        <Dropdown className="w-100 connected_acc__" id="connectedAll">
                            <Dropdown.Toggle className="btn w-100 border d-flex justify-content-between align-items-center mt-5">
                                {selectedAcc ? selectedAcc.name : "Select Group"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100 navi flex-column navi-hover py-2 connectedAllAccounts">
                                {
                                    groupList.map(item => (<Dropdown.Item className="navi-item px-5 py-3" onClick={e => this.handleSelect(item)} key={item.id}>
                                        {item.name}
                                    </Dropdown.Item>))
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>}
                    {error && <span id="workplace_error" className="errorMessage">Community ID and Access Token required!</span>}
                    {noAccFoundError && <span id="workplace_error" className="errorMessage">No Group Found !</span>}
                    <div className="form-group hideforBSearch mt-3">
                        <div className="checkbox-inline mb-2">
                            <CheckBoxField isChecked={isChecked} onChangeHandler={(e) => this.setState({ isChecked: e.target.checked })} name={"moderation"} id="checkbox_workplace" />
                        </div>
                    </div>
                </div>

                <div className="form-actions w-100">
                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                        {getInitialRoute() === 'widget' ?
                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://player.vimeo.com/video/497245578'} supportLink={'https://taggbox.com/support/how-to-add-feeds-to-taggbox-widget/'} />
                            :
                            <NeedHelp text={'Need help in adding feeds?'} videoUrl={'https://vimeo.com/537156875/8345161190'} supportLink={''} />}
                        {isAccountSelected && <SubmitFeedRequest onSubmit={this.submit} onBack={onBack} loading={loading} />}
                    </div>
                </div>
            </>
        )
    }
}

export default WorkPlacefeed;
